export const TOOL_ANCHOR_CLASS = "scroll-mt-24";

export function toolAnchorId(toolId: string): string {
    return `outil-${toolId}`;
}
